import * as RefreshStateActions from '../actions/refresh-state.actions';

export type Actions = RefreshStateActions.Actions;

export function refreshStateReducer(state: boolean = false, action: Actions) {

  switch (action.type) {
    case RefreshStateActions.REFRESH_STATE:
      state = action.payload;
      return state;
    case RefreshStateActions.RESET_STATE:
      state = false;
      return state;
    default:
      return state;
  }
}
